import { Button } from "@/components/ui/button";
import useActiveIndustryData from "@/module/hook/useActiveIndustryData";
import { PlusCircle } from "lucide-react";
import EducationAccordan from "./EducationAccordan";
import { useChildForm } from "@/features/leads/contexts/ChildProvider";
import { useActiveDataMutation } from "@/features/leads/hook/useActiveDataMutation";
import { useAppSelector } from "@/stores/hook";

export default function EducationChildOverview() {
  const { smartRoute } = useActiveIndustryData();
  const { lead } = useActiveDataMutation();
  const { currentChildsOnSelectedStage } = useChildForm();
  const { stageId } = useAppSelector((state) => state.childFunctional);
  const handleAddDeal = () => {
    smartRoute();
  };

  const disabled = stageId !== lead?.stage?.id;

  return (
    <>
      {currentChildsOnSelectedStage.length > 0 ? (
        <EducationAccordan />
      ) : (
        /* --- EMPTY STATE --- */
        <div className="flex flex-col items-center justify-center py-10 px-4 text-center border-2 border-dashed border-gray-200 rounded-lg bg-gray-50/50">
          <p className="text-sm text-muted-foreground mb-4 font-medium">
            No Choices (Deals) found
          </p>
          <Button
            variant="outline"
            onClick={handleAddDeal}
            className="gap-2"
            disabled={disabled}
          >
            <PlusCircle className="h-4 w-4" />
            {disabled ? "You are not allowed to add a deal" : "Click to add"}
          </Button>
        </div>
      )}
    </>
  );
}
